<rb-auth-container [title]="'MAINTENANCE.TITLE'">
  <p class="text-center">{{ 'MAINTENANCE.MESSAGE' | translate }}</p>
  <div class="flex justify-center py-[2rem]">
    <mat-icon class="icon-40 icon-brand" svgIcon="maintenance"></mat-icon>
  </div>
</rb-auth-container>
